import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import { FLOAT_ACTION_BOTTOM, FLOAT_ACTION_SIZE } from '@/components/layout/floatingActions'
import { cn } from '@/lib/utils'

const SHOW_AFTER_PX = 320

export function BackToTopButton() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX)

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      className={cn(
        'fixed right-4 z-40 flex items-center justify-center rounded-full border border-primary-100 bg-primary-50 text-primary-600 shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:bg-primary-100 hover:text-primary-700 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40',
        FLOAT_ACTION_BOTTOM,
        FLOAT_ACTION_SIZE,
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2 opacity-0',
      )}
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
    </button>
  )
}
